import { Component, default as React } from "react";
import Header from "../components/Header/Header";
import Menu from "../components/Menu/Menu";
import PageContainer from "../containers/PageContainer";
import MainSearchBox from "../containers/MainSearchBox";
import MainTopFive from "../containers/MainTopFive";
import EconomyDataInterface from "../objects/EconomyDataInterface";
import ServerStatisticsInterface from "../objects/ServerStatisticsInterface";
import SimpleStatsBox from "../containers/SimpleStatsBox";
import {
	fetchGlobalLevelsLeaderboard,
	fetchPlaytimeLeaderboard, fetchServerStatistics,
	fetchServerStatus,
	fetchTotalVotes
} from "../services/ApiContext";

interface MainPageState {
	playerCount: number;
	voteLeaderboard: EconomyDataInterface[];
	playtimeLeaderboard: EconomyDataInterface[];
	globalLevelsLeaderboard: EconomyDataInterface[];
	serverStatistics: ServerStatisticsInterface | null;
}

class MainPage extends Component<any, MainPageState> {

	constructor(props: any) {
		super(props);
		this.state = {
			playerCount: 0,
			voteLeaderboard: [],
			playtimeLeaderboard: [],
			globalLevelsLeaderboard: [],
			serverStatistics: null
		};
	}

	public async componentDidMount() {
		const serverData = await fetchServerStatus();
		const totalVotes = await fetchTotalVotes();
		const playtimeLeader = await fetchPlaytimeLeaderboard();
		const globalLevels = await fetchGlobalLevelsLeaderboard();
		const serverStatistics = await fetchServerStatistics();
		this.setState({
			playerCount: serverData.players.online,
			voteLeaderboard: totalVotes,
			playtimeLeaderboard: playtimeLeader,
			globalLevelsLeaderboard: globalLevels,
			serverStatistics: serverStatistics
		});
	}

	public render() {
		if (this.state.voteLeaderboard === null || this.state.serverStatistics === null) {
			return null;
		}
		return (
			<PageContainer>
				<Header/>
				<main id="main-container">
					<Menu/>
					<MainSearchBox
						playercount={this.state.playerCount}
						registredPlayers={this.state.serverStatistics.totalPlayers}
						props={this.props}
					/>
					<div className="content content-full">
						<div className="d-flex justify-content-between align-items-center py-3">
							<h2 className="h3 font-w400 mb-0">Přehled</h2>
						</div>
						<div className="row">
							<MainTopFive
								title="Global level"
								icon="fa-trophy"
								leaderboard={this.state.globalLevelsLeaderboard}
								isTime={false}
								gradient="bg-gd-xpro"
								link="/leaderboard/server/global"
							/>
							<MainTopFive
								title="Celkem hlasů"
								icon="fa-user-friends"
								leaderboard={this.state.voteLeaderboard}
								isTime={false}
								gradient="bg-gd-xplay"
								link="/leaderboard/votes/total"
							/>
							<MainTopFive
								title="Odehraný čas"
								icon="fa-clock"
								leaderboard={this.state.playtimeLeaderboard}
								isTime={true}
								gradient="bg-gd-lake-op"
								link="/leaderboard/economy/played-time"
							/>
						</div>
						<div className="d-flex justify-content-between align-items-center pt-5 pb-3">
							<h2 className="h3 font-w400 mb-0">Souhrnné statistiky</h2>
						</div>
						<div className="row row-deck">
							<SimpleStatsBox title="Celkem CraftCoins"
											value={this.state.serverStatistics.totalCraftCoins}/>
							<SimpleStatsBox title="Celkem CraftTokens"
											value={this.state.serverStatistics.totalCraftTokens}/>
							<SimpleStatsBox title="Celkem VoteTokens"
											value={this.state.serverStatistics.totalVoteTokens}/>
							<SimpleStatsBox title="Registrováno hráčů"
											value={this.state.serverStatistics.totalPlayers}/>
							<SimpleStatsBox title="Měsíční hlasy" value={this.state.serverStatistics.monthVotes}/>
							<SimpleStatsBox title="Týdenní hlasy" value={this.state.serverStatistics.weekVotes}/>
							<SimpleStatsBox title="Noví hráči za měsíc"
											value={this.state.serverStatistics.newPlayersPerMonth}/>
							<SimpleStatsBox title="Noví hráči za týden"
											value={this.state.serverStatistics.newPlayersPerWeek}/>
							<SimpleStatsBox title="Celkově odehraný čas"
											time={this.state.serverStatistics.totalPlayTime}/>
							<SimpleStatsBox title="Splněno questů"
											value={this.state.serverStatistics.totalCompletedQuests}/>
							<SimpleStatsBox title="Počet hráčů s VIP"
											value={this.state.serverStatistics.playersWithVIP}/>
							<SimpleStatsBox title="Počet originálek"
											value={this.state.serverStatistics.totalMcOriginals}/>
						</div>
					</div>
				</main>
			</PageContainer>
		);
	}
}

export default MainPage;
